// supportForm.js (updated)
document.getElementById("supportForm").addEventListener("submit", async function (event) {
  event.preventDefault();
  const form = this;

  // UI: spinner & messages
  document.getElementById("support-spinner").style.display = "block";
  form.style.display = "none";
  document.getElementById("support-successMessage").style.display = "none";
  document.getElementById("support-errorMessage").style.display = "none";

  // Disable submit button (robust selector)
  const submitButton =
    document.getElementById("supportSubmit") ||
    form.querySelector('button[type="submit"], input[type="submit"]');
  if (submitButton) submitButton.setAttribute("disabled", "disabled");

  try {
    // --- Get Turnstile token (widget auto-injects a hidden input into the form)
    const captchaToken =
      form.querySelector('input[name="cf-turnstile-response"]')?.value ||
      (window.turnstile && window.turnstile.getResponse ? window.turnstile.getResponse(form) : "");

    if (!captchaToken) {
      throw new Error("Please complete the CAPTCHA challenge.");
    }

    // Build payload from form
    const formData = new FormData(form);
    const obj = {};
    formData.forEach((value, key) => (obj[key] = value));

    // Include Turnstile token
    obj["cf-turnstile-response"] = captchaToken;

    // Preserve your GCLID logic
    const storedGclid = localStorage.getItem("gclid");
    if (storedGclid) obj.gclid = storedGclid;

    const response = await fetch("https://portal.lanesharkusa.com/api/public/contact-form-shopify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const data = await response.json();

    // UI: success
    document.getElementById("support-spinner").style.display = "none";
    if (submitButton) submitButton.removeAttribute("disabled");

    if (data.message === "success") {
      form.style.display = "none";
      document.getElementById("support-successMessage").style.display = "block";
    document.getElementById("support-successMessage").focus(); // a11y: move focus to the result
    } else {
      throw new Error("Unexpected server response");
    }
  } catch (err) {
    console.error("Error:", err);

    // UI: error
    document.getElementById("support-spinner").style.display = "none";
    document.getElementById("support-errorMessage").style.display = "block";
    document.getElementById("support-errorMessage").focus(); // a11y: move focus to the result
    form.style.display = ""; // show form again so they can retry
  } finally {
    if (submitButton) submitButton.removeAttribute("disabled");
    // Refresh Turnstile token for the next attempt (if widget present)
    if (window.turnstile && typeof window.turnstile.reset === "function") {
      window.turnstile.reset();
    }
  }
});